import { Controller } from '@hotwired/stimulus'

// Switches the Locations page between shelter locations and IMH hubs.
// Each source has its own map page, so this does a full page load.
export default class LocationSourceController extends Controller {
  navigate (event) {
    window.location.assign(event.target.value)
  }
}
